import {
  UPDATE_CLIENT_USER,
  UPDATE_CLIENT_USER_SUCCESS,
  UPDATE_CLIENT_USER_ERROR
} from "./actionTypes"

export const updateClientUser = (client_user) => ({
  type: UPDATE_CLIENT_USER,
  payload: client_user
})

export const updateClientUserSuccess = (client_user) => ({
  type: UPDATE_CLIENT_USER_SUCCESS,
  payload: client_user
})

export const updateClientUserError = (error) => ({
  type: UPDATE_CLIENT_USER_ERROR,
  payload: error
})
